import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { CreditosModel } from './creditos.model';
import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'convfact-creditos-form',
    templateUrl: './creditos-form.component.html',
    styleUrls: ['./creditos.component.css'],
    standalone: false
})
export class CreditosFormComponent implements OnInit {

  @Input() creditos: CreditosModel;
  @Output() onSave = new EventEmitter<any>();

  public loading = false;
  public ready = false;



  public selectAccountList: any[] = [
    { id: '5323', name: 'Créditos A Corto Plazo A Empresas Del Grupo - 5323' },
    { id: '5324', name: 'Créditos A Corto Plazo A Empresas Asociadas - 5324' },
    { id: '5325', name: 'Créditos A Corto Plazo A Otras Partes Vinculadas - 5325' },
    { id: '2423', name: 'Créditos A Largo Plazo A Empresas Del Grupo - 2423' },
    { id: '2424', name: 'Créditos A Largo Plazo A Empresas Asociadas - 2424' },
    { id: '2425', name: 'Créditos A Largo Plazo A Otras Partes Vinculadas - 2425' },
  ];

  public bankAccounts: BankAccountModel[] = [];

  public get cuentaContableOptions(): Option[] {
    return this.selectAccountList.map(item => ({ label: item.name, value: item.id }));
  }

  constructor(
    public snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public bankAccountService: BankAccountService,
    private masterService: MasterService,
  ) { }

  public ngOnInit(): void {
    this.ready = false;

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;
        this.ready = true;
      });

  }

 public save(): void {
  this.loading = true;
  let noError = true;
  const missing: string[] = [];

  if (this.creditos.cuentaContableACrear == null) {
    noError = false;
    missing.push('Cuenta');
  }

  if (this.creditos.importeInicial == null) {
    noError = false;
    missing.push('Importe inicial');
  }

  if (this.creditos.importePendiente == null) {
    noError = false;
    missing.push('Importe pendiente');
  }

  if (this.creditos.fechaConstitucion == null) {
    noError = false;
    missing.push('Fecha de constitución');
  }

  if (this.creditos.plazo == null) {
    noError = false;
    missing.push('Plazo');
  }

  if (this.creditos.fechaFinalizacion == null) {
    noError = false;
    missing.push('Fecha de finalización');
  }

  if (this.creditos.tipoInteres == null) {
    noError = false;
    missing.push('Tipo de Intereses');
  }

  if (this.creditos.carencia == null) {
    noError = false;
    missing.push('Carencia');
  }

  if (this.creditos.tipoLiquidaciones == null || this.creditos.tipoLiquidaciones === 0) {
    noError = false;
    missing.push('Tipos de liquidaciones');
  }

  if (this.creditos.bankAccountsUid == null || this.creditos.bankAccountsUid === consts.EMPTY_GUID) {
    noError = false;
    missing.push('Cuenta de abono');
  }

  if (missing.length) {
    this.displayInfo('Revisa los campos obligatorios: ' + missing.join(', '));
  }

  this.setDefaultsValues();


  if (noError) {
    this.onSave.emit(this.creditos);
  }

  this.loading = false;
}


  public setDefaultsValues(): void {
    // Valores por defecto en los campos que no sean requeridos
  }

  public setTipoDeLiquidacionesOptions(value: number) {
    this.creditos.tipoLiquidaciones = value;
  }

  public duracionChangeValue(corto_largo_plazo_id: number) {

    this.selectAccountList = [];

    this.creditos.accountingModelsCortoPlazoNumber = null;
    this.creditos.accountingModelsLargoPlazoNumber = null;
    this.creditos.cuentaContableACrear = null;


    // Corto plazo
    if (corto_largo_plazo_id === 1) {

      this.selectAccountList = [
        { id: '5323', name: 'Créditos A Corto Plazo A Empresas Del Grupo - 5323' },
        { id: '5324', name: 'Créditos A Corto Plazo A Empresas Asociadas - 5324' },
        { id: '5325', name: 'Créditos A Corto Plazo A Otras Partes Vinculadas - 5325' },
      ];

    }

    // Largo plazo
    if (corto_largo_plazo_id === 2) {

      this.selectAccountList = [
        { id: '2423', name: 'Créditos A Largo Plazo A Empresas Del Grupo - 2423' },
        { id: '2424', name: 'Créditos A Largo Plazo A Empresas Asociadas - 2424' },
        { id: '2425', name: 'Créditos A Largo Plazo A Otras Partes Vinculadas - 2425' },
      ];

    }
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public trackByIndex(i: number) { return i; }

}
